import { Controller } from "stimulus";
import Choices from "choices.js";

export default class extends Controller {

  static targets = ["coinSelect", "paywallEndDateTime", "categorySelect", "isPaywall"];

  connect() {
    this.learnOptions         = this.data.get("url-value")
    this.premiumOptions       = this.data.get("premium-value")
    this.selectedCategoryType = this.data.get("selected-category-type-value")

    new Choices(this.coinSelectTarget, {
      removeItemButton: true,
    });

    this.populateSelectField();
  }

  setPaywallEndDateTimeToNextWeek(e) {
    if (e.target.checked === true) {
      const date = new Date();
      date.setDate(date.getDate() + 7);
      this.paywallEndDateTimeTarget.value = date.toISOString().slice(0, 16);
    } else {
      this.paywallEndDateTimeTarget.value = "";
    }
  }

  populateSelectField() {

    let premiumOptions = JSON.parse(this.premiumOptions)
    let learnOptions = JSON.parse(this.learnOptions)

    if (this.isPaywallTarget.checked === true) {
      premiumOptions.forEach((elem) => {
        let option = document.createElement("option");
        option.value = elem[1];
        option.text  = elem[0];
        if (elem[0] === this.selectedCategoryType) {
          option.selected = true
        }
        this.categorySelectTarget.appendChild(option);
      })
    } else {
      learnOptions.forEach((elem) => {
        let option = document.createElement("option");
        option.value = elem[1];
        option.text  = elem[0];
        if (elem[0] === this.selectedCategoryType) {
          option.selected = true
        }
        this.categorySelectTarget.appendChild(option);
      })
    }
  }

  updateSelectField(e) {
    this.categorySelectTarget.innerHTML = null

    let premiumOptions = JSON.parse(this.premiumOptions)
    let learnOptions = JSON.parse(this.learnOptions)

    // will break if either options are empty
    if (e.target.checked === true) {
      premiumOptions.forEach((elem) => {
        let option = document.createElement("option");
        option.value = elem[1];
        option.text  = elem[0];
        this.categorySelectTarget.appendChild(option);
      })
    } else {
      learnOptions.forEach((elem) => {
        let option = document.createElement("option");
        option.value = elem[1];
        option.text  = elem[0];
        this.categorySelectTarget.appendChild(option);
      })
    }
  }
}
